const AMAZON_IMG_BASE = 'https://m.media-amazon.com/images/I/';

function isMissingTextId(value) {
  return (
    value === null
    || value === undefined
    || value === ''
    || value === 0
    || value === '0'
  );
}

/**
 * summary.img を Amazon 画像 URL に正規化する。
 * 旧データはファイル名のみ、enrich 後はフル URL が入ることがある。
 */
export function amazonImgSrc(img) {
  if (img === null || img === undefined) return '';
  const s = String(img).trim();
  if (!s || s === '0') return '';
  if (/^https?:\/\//i.test(s)) return s;
  const m = s.match(/\/images\/I\/([^/?#]+)/i);
  if (m) return `${AMAZON_IMG_BASE}${m[1]}`;
  return AMAZON_IMG_BASE + s;
}

export function itemImgSrc(img, channel) {
  if (channel === 1) return amazonImgSrc(img);
  const s = img === null || img === undefined ? '' : String(img).trim();
  return s && s !== '0' ? s : '';
}

/** 施策分析など: tracking の img_url を表示用 URL に（無ければ fallback） */
export function resolveTrackingImgSrc(imgUrl, channel, fallback = '') {
  if (isMissingTextId(imgUrl) || imgUrl === '-') {
    return fallback;
  }
  const src = itemImgSrc(imgUrl, channel);
  return src || fallback;
}

/** 登録商品のモール商品ページ URL（latest_data 非依存） */
export function buildMallProductHref(item, channel) {
  const itemId = item.item_id;
  const shopCode = item.shop_code;

  if (isMissingTextId(itemId)) {
    return '';
  }
  if (channel === 1) {
    return `https://www.amazon.co.jp/dp/${itemId}`;
  }
  if (isMissingTextId(shopCode)) {
    return '';
  }
  return `https://item.rakuten.co.jp/${shopCode}/${itemId}/`;
}
